/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { EMPTY_STRING } from '@/data/constants/marketing';
import { ProductType } from '@/data/types/Product';

export const getProductDisplayInfo = (
	input: ProductType | undefined,
	fallback: ProductType | undefined
) => {
	const { productPrice: prices } = input ?? {};
	const imageStoreDomain_PDPPath = process.env.NEXT_PUBLIC_IMAGE_STORE_DOMAIN_PDPPATH??"";
	const {
		name = EMPTY_STRING,
		partNumber = EMPTY_STRING,
		shortDescription: short = EMPTY_STRING,
		longDescription: long = EMPTY_STRING,
		seller,
		sellerId = '',
		components,
	} = input ?? {};

	const descriptiveAttributes =
		input?.descriptiveAttributes ?? fallback?.descriptiveAttributes ?? [];

	let attachments = fallback?.attachments ?? [];
	attachments = attachments.filter(a=> (a.attachmentAssetPath.toLocaleLowerCase().includes('pdf')) );

	attachments.forEach((item) => { 
		if(item.attachmentAssetPath?.toLocaleLowerCase().includes('intertoyscas') && !item.attachmentAssetPath?.toLocaleLowerCase().includes(imageStoreDomain_PDPPath)){
			item.attachmentAssetPath = imageStoreDomain_PDPPath+item.attachmentAssetPath;		  
		}		 
	} );
  
	
	const longDescription = long ?? fallback?.longDescription ?? '';
	const shortDescription = short ?? fallback?.shortDescription ?? '';
	const longCompDesc = components?.map((c) => c.name) as string[];
	return {
		prices,
		name,
		partNumber,
		short,
		seller: seller ? { name: seller, id: sellerId } : null,
		tabsData: { descriptiveAttributes, attachments, longDescription, longCompDesc, shortDescription },
	};
};
